import Panel from "./Panel.jsx";
import { formatNumber, formatPercent, formatUsd } from "../lib/utils/formatters.js";

export default function BacktestPanel({ result = {} }) {
  return (
    <Panel title="Бэктестинг" icon="chart">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        <Stat label="Стратегия" value={result.strategyName ?? "EMA 9/21 Crossover"} />
        <Stat label="Итоговая стоимость" value={formatUsd(result.finalValue)} />
        <Stat label="Доходность" value={formatPercent(result.returnPercent)} />
        <Stat label="Сделки" value={formatNumber(result.numberOfTrades, 0)} />
        <Stat label="Макс. просадка" value={formatPercent(result.maxDrawdown)} />
      </div>
      <div className="mt-4 overflow-x-auto thin-scrollbar">
        <table className="w-full min-w-[560px] border-collapse text-left text-sm">
          <thead className="text-xs text-muted">
            <tr className="border-b border-white/10">
              <th className="py-2 font-medium">Дата</th>
              <th className="py-2 font-medium">Сигнал</th>
              <th className="py-2 font-medium">Цена</th>
              <th className="py-2 font-medium">Объем</th>
              <th className="py-2 font-medium">P/L</th>
            </tr>
          </thead>
          <tbody>
            {(result.trades ?? []).length ? (
              result.trades.map((trade, index) => (
                <tr key={`${trade.date}-${index}`} className="border-b border-white/10 last:border-b-0">
                  <td className="py-2 text-slate-300">{trade.date ?? "н/д"}</td>
                  <td className="py-2 font-medium text-white">{trade.type}</td>
                  <td className="py-2 text-slate-300">{formatUsd(trade.price)}</td>
                  <td className="py-2 text-slate-300">{trade.ounces ? `${formatNumber(trade.ounces, 3)} oz` : "н/д"}</td>
                  <td className={Number(trade.profit) >= 0 ? "py-2 text-mint" : "py-2 text-rose"}>
                    {trade.profit == null ? "н/д" : formatUsd(trade.profit)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="py-3 text-slate-400" colSpan="5">
                  В историческом окне пока нет сделок.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {result.warning ? <p className="mt-3 text-sm text-goldSoft">{result.warning}</p> : null}
    </Panel>
  );
}

function Stat({ label, value }) {
  return (
    <div className="rounded-md border border-white/10 bg-white/[0.03] p-3">
      <div className="text-xs text-muted">{label}</div>
      <div className="mt-1 text-sm font-semibold text-white">{value}</div>
    </div>
  );
}
